export const COLOR_PROPERTY = 'colorCode'

export const MAX_COLORS_PER_VIEW = 7
